import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChildTicket = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.8335 12.4999L10.8335 17.4999L9.65016 16.3166L12.6418 13.3333H3.3335V3.33325H5.00016V11.6666H12.6418L9.65016 8.68325L10.8335 7.49992L15.8335 12.4999Z",
		fill: "#424D57"
	})
});
export default SvgChildTicket;
